module.exports = __webpack_public_path__ + "files/c888fd213e5bba3fbd93b46735776ef0.png";